const vehicleType = {
  regular: 'regular',
  ODC: 'over dimensional cargo',
};

const subSupplyType = {
  others: 'Others',
  supply: 'Supply',
};

const transportationMode = {
  road: 'Road',
  rail: 'Rail',
  air: 'Air',
  ship: 'Ship',
};

const supplyType = {
  primary: 'Inward',
  secondary: 'Outward',
};

const transactionType = {
  regular: 1,
};

const generateStatus = {
  generate: 1,
};

const eWayBillStatus = {
  partAIncomplete: 'AINC',
  partAComplete: 'AC',
  partAAndBComplete: 'ABC',
};

const eWayBillGenerationStatus = {
  notGenerated: 1,
  generated: 2,
  modified: 3,
  extended: 5,
  cancelled: 6,
  failed: 7,
};

const eWayBillAcknowledgementStatus = {
  notAcknowledged: 1,
  acknowledged: 2,
};

const eWayBillStatusList = [
  { id: 1, name: 'Not Generated' },
  { id: 2, name: 'Generated' },
  { id: 3, name: 'Modified' },
  { id: 5, name: 'Extended' },
  { id: 6, name: 'Cancelled' },
  { id: 7, name: 'Failed (In Correct data)' },
];

const eWAYBillGenerationMsg = {
  generated: 'EWay Bill generated',
  error: 'Error in generating EWay Bill',
};

const documentType = {
  taxInvoice: 'Tax invoice',
};

const eWayBillDateFormat = 'YYYY-MM-DD';

const unitOfProduct = {
  pcs: 'PCS',
};

const EWayBillHistoryType = {
  TIMELINE: 'timeline',
  FAILURES: 'failures',
  MASTERS_INDIA: 'masters_india',
};

const EWayBillActionType = {
  GENERATE: 'generate',
  EXTEND: 'extend',
  CANCEL: 'cancel',
  VEHICLE_UPDATE: 'vehicle_update',
  TRANSPORTER_UPDATE: 'transporter_update',
};

const EWayBillHistoryMessages = {
  EWAY_BILL_SUCCESSFULLY_GENERATED: 'Eway Bill successfully generated',
  EWAY_BILL_NUMBER_MISSING: 'EwayBill no. missing. Possibily incorrect data',
  EWAY_BILL_GENERATION_FAILED: 'EWayBill Generation Failed',
  EWAY_BILL_CANCELLED: 'EWayBill Cancellation successful',
  EWAY_BILL_CANCELLATION_FAILED: 'EwayBill Cancellation failed',
  EWAY_BILL_EXTENDED: 'EWayBill extended',
  EWAY_BILL_EXTENTION_FAILED: 'EWayBill Extension failed',
  EWAY_BILL_VEHICLE_UPDATED: 'EWayBill Vehicle updated',
  EWAY_BILL_VEHICLE_UPDATE_FAILED: 'EWayBill vehicle update failed',
  EWAY_BILL_TRANSPORTER_UPDATED: 'EWayBill Transporter updated!!',
  EWAY_BILL_TRANSPORTER_UPDATE_FAILED: 'EWayBill Transporter update failed :(',
};

const EWayBillHistoryTypes = Object.values(EWayBillHistoryType);

const EWayBillHistoryActionTypes = Object.values(EWayBillActionType);

const ObjectIdInvalidMessage = 'Invalid ID';

const HISTORY_PER_PAGE = 10;

module.exports = {
  vehicleType,
  transportationMode,
  supplyType,
  transactionType,
  subSupplyType,
  generateStatus,
  eWayBillStatus,
  eWayBillGenerationStatus,
  eWAYBillGenerationMsg,
  documentType,
  eWayBillStatusList,
  eWayBillDateFormat,
  unitOfProduct,
  EWayBillHistoryType,
  EWayBillActionType,
  EWayBillHistoryTypes,
  EWayBillHistoryActionTypes,
  EWayBillHistoryMessages,
  ObjectIdInvalidMessage,
  HISTORY_PER_PAGE,
  eWayBillAcknowledgementStatus,
};
